import React from 'react';
import { CalendarDays, ChevronRight, Clock3, MapPin } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { formatRosterServiceDate } from './rosterUtils';

const STATUS_LABELS = {
  concept: 'Concept', gepland: 'Gepland', bevestigd: 'Bevestigd',
  afgerond: 'Afgerond', geannuleerd: 'Geannuleerd',
};

const RosterServiceRow = ({ service, historical = false, onOpen }) => {
  const memberCount = service.assignments?.length || 0;
  const statusLabel = STATUS_LABELS[service.status] || service.status;

  return (
    <button
      type="button"
      onClick={() => onOpen(service)}
      className={`group grid w-full gap-2 border-b border-slate-100 px-4 py-3.5 text-left transition last:border-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-teal-500 sm:grid-cols-[130px_minmax(0,1fr)_minmax(150px,0.8fr)_auto_auto] sm:items-center sm:gap-4 sm:px-5 ${historical ? 'text-slate-500 hover:bg-slate-50' : 'hover:bg-teal-50/40'}`}
    >
      <span className={`flex items-center gap-2 text-sm font-semibold capitalize ${historical ? 'text-slate-600' : 'text-slate-800'}`}>
        <CalendarDays className={`h-4 w-4 shrink-0 ${historical ? 'text-slate-400' : 'text-teal-600'}`} />
        {formatRosterServiceDate(service.service_date)}
      </span>
      <span className="min-w-0 pl-6 sm:pl-0">
        <span className={`block truncate font-semibold ${historical ? 'text-slate-700' : 'text-slate-900'}`}>{service.title}</span>
        <span className="mt-0.5 block truncate text-sm text-slate-500 sm:hidden">
          {service.start_time}–{service.end_time}{service.location ? ` · ${service.location}` : ''}
        </span>
      </span>
      <span className="flex flex-wrap items-center gap-x-3 gap-y-1 pl-6 text-sm text-slate-500 sm:pl-0">
        <span className="inline-flex items-center gap-1"><Clock3 className="h-3.5 w-3.5" />{service.start_time}–{service.end_time}</span>
        {service.location && <span className="inline-flex items-center gap-1"><MapPin className="h-3.5 w-3.5" />{service.location}</span>}
      </span>
      <span className="pl-6 text-sm text-slate-500 sm:pl-0">{memberCount} ingepland</span>
      {historical ? (
        <span className="hidden text-xs text-slate-400 sm:block">Voorbij</span>
      ) : (
        <Badge variant="secondary" className="ml-6 w-fit text-xs font-medium sm:ml-0">{statusLabel}</Badge>
      )}
      <ChevronRight className="hidden h-4 w-4 text-slate-300 transition group-hover:text-teal-600 sm:block" />
    </button>
  );
};

export default RosterServiceRow;
